import React, { useEffect, useState } from 'react';
// import { useRouter } from 'next/router';
import Head from 'next/head';
import PageLoader from '../components/pageLoader';
import Layout from '../components/layout';
import getTitleFromPage from '../utils/data/getTitleFromPage';
import { fetchMenus } from '../utils/data/fetch';

const FourOhFour = () => {
  // const router = useRouter();
  const [menus, setMenus] = useState<WordpressHeaderMenu[] | null>(null);
  useEffect(() => {
    //   router.route
    //   if (asPath.endsWith('/')) {
    //     res.writeHead(301, {Location: asPath.substring(0, asPath.length - 1)});
    //     return res.end();
    // }

    fetchMenus().then((m: any) => {
      setMenus(m);
    });
  }, []);
  const title = getTitleFromPage('Page not foud');
  return (
    <>
      <Head>
        <title key='title'>{title}</title>
      </Head>
      {menus ? (
        <Layout menus={menus}>
          <div className='flex flex-col h-full w-full items-center justify-center'>
            <img src='/images/404.jpg' />
            <h2 className='mb-16 text-2xl sm:text-3xl md:text-4xl font-sans text-center'>
              Oops - looks like we had one too many and messed this link up!
            </h2>
          </div>
        </Layout>
      ) : (
        <PageLoader />
      )}
    </>
  );
};

export default FourOhFour;
